import { gql } from '@apollo/client';

export const GET_SHORTCUT = gql`
  query shortcut($id: Int!) {
    shortcut(id: $id) {
      id
      template_id
      type
      title
      description
      path
      args
      main_picture
      screenshots
      popular
      work_dir
      group_id
      icon_path
      run_as_admin
      only_for_registered
      age_rating
      free_run
      game_account_group {
        id
        title
      }
    }
  }
`;

export const GET_SHORTCUTS_GROUP = gql`
  query shortcutGroups {
    shortcutGroups {
      id
    }
  }
`;

export const CREATE_BILLING_SHORTCUT = gql`
  mutation createShortcut($input: ShortcutInput!, $sync: SyncScope) {
    createShortcut(input: $input, sync: $sync) {
      id
      type
    }
  }
`;

export const UPDATE_BILLING_SHORTCUT = gql`
  mutation updateShortcut($id: Int!, $input: ShortcutInput!, $sync: SyncScope) {
    updateShortcut(id: $id, input: $input, sync: $sync) {
      id
      type
    }
  }
`;

export const DELETE_BILLING_SHORTCUT = gql`
  mutation deleteShortcut($id: Int!, $sync: SyncScope) {
    deleteShortcut(id: $id, sync: $sync) {
      type
    }
  }
`;

export const GAME_ACCOUNTS_GROUPS = gql`
  query gameAccountGroups {
    gameAccountGroups {
      id
      title
    }
  }
`;

export const GET_SHORTCUT_TEMPLATES = gql`
  query ShortcutTemplatesV2 {
    shortcutTemplates {
      id
      title
      age_rating
    }
  }
`;

export const GET_SHORTCUT_TEMPLATE = gql`
  query ShortcutTemplateV2($shortcutTemplateId: Int!) {
    shortcutTemplate(id: $shortcutTemplateId) {
      id
      title
      args
      main_picture
      run_as_admin
      age_rating
      description
      screenshots
    }
  }
`;
